import { MenuProps, SiteRegionTypes } from './ContentfulNavigation.d'

// export const MainNavigationMenu: MainNavigationMenuProps = {
export const getMainNavigationMenu = (
  menus: MenuProps[],
  siteRegion?: SiteRegionTypes
) => {
  return {
    restaurantUrl: 'https://www.toasttab.com/local?referrer=pos',
    loginUrl: 'https://www.toasttab.com/login',
    demoUrl: '/request-demo',
    menus,
    siteRegion
  }
}
